import React, { useContext } from 'react';
import {
  Button,
  Flex,
  Text,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
import ReadersListContext from '../../../store/client/ReadersListContext';
import ReaderListFilter from './ReaderListFilter';
import { MeContext } from '../../../context/MeContext';
import { Link as RouterLink } from 'react-router-dom';
import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import LockedActionButton from '../../common/LockedActionButton';

function getFiltersString(filters) {
  const { name, uuid, type } = filters;

  if (name === '' && uuid === '' && type === '') {
    return '';
  }

  let values = [];
  if (name !== '') {
    values.push(name);
  }
  if (uuid !== '') {
    values.push(uuid);
  }
  if (type !== '') {
    values.push(type);
  }

  const count = values.length;
  let outString = '';
  values.forEach((value, index) => {
    if (index === count - 1) {
      outString = outString + value;
    } else {
      outString = outString + value + ', ';
    }
  });

  return outString;
}

function ReaderListHeader() {
  const readerListCtx = useContext(ReadersListContext);
  const filters = getFiltersString(readerListCtx.filterValues);
  const filterModeColor = useColorModeValue('secondaryDark08', 'white');
  const meCtx = useContext(MeContext);
  const isSetUpConfirmed = meCtx?.isSetUpConfirmed() ?? true;
  const isReadOnly = useIsReadOnly();
  const { filterEntity } = meCtx.state;
  const multipleEntities = meCtx?.state?.entities?.length > 1;
  const bgTooltip = useColorModeValue('secondaryDark', '#dddddd');
  const textTooltip = useColorModeValue('#ffffff', 'primaryDark');

  return (
    <>
      <PageHeadingWithTrialProgress
        title={
          <>
            {filters === '' ? 'Readers' : `Filter results: `}
            <Text
              as="span"
              display="inline-block"
              textStyle="bodyFamilyMedium"
              fontSize="16px"
              color={filterModeColor}
              wordBreak="break-word"
            >
              {filters}
            </Text>
          </>
        }
      />
      <Flex
        flexDirection={{ base: 'column', sm: 'row' }}
        flexWrap="wrap"
        mb="10px"
        justifyContent="space-between"
        w="100%"
      >
        <Flex
          gap={{ base: '10px' }}
          alignItems="center"
          justifyContent="flex-start"
          flexWrap="wrap"
          mb={{ base: '10px', sm: '0px' }}
        >
          {isSetUpConfirmed && (
            <Tooltip
              label="You need to select an entity first"
              isDisabled={!multipleEntities || !!filterEntity}
              hasArrow
              placement="right"
              fontSize="12px"
              borderRadius="6px"
              p="10px"
              bg={bgTooltip}
              color={textTooltip}
            >
              <Button
                alt="Reader configuration"
                mr={{ base: '0px', sm: '10px' }}
                px={{ base: '20px', sm: '30px' }}
                size="sm"
                isDisabled={multipleEntities && !filterEntity}
                as={RouterLink}
                to="/readers/reader-configuration"
              >
                Reader Configuration
              </Button>
            </Tooltip>
          )}
        </Flex>
        <Flex
          gap={{ base: '10px', sm: '0px' }}
          alignItems="flex-end"
          justifyContent="flex-end"
          flexWrap="wrap"
        >
          {isSetUpConfirmed &&
            (isReadOnly ? (
              <LockedActionButton
                mr={{ base: '0px', sm: '10px' }}
                px={{ base: '20px', sm: '40px' }}
                size="sm"
              >
                Add reader
              </LockedActionButton>
            ) : (
              <Button
                alt="Add reader"
                mr={{ base: '0px', sm: '10px' }}
                px={{ base: '20px', sm: '40px' }}
                size="sm"
                as={RouterLink}
                to="/readers/create"
              >
                Add reader
              </Button>
            ))}
          {isSetUpConfirmed && <ReaderListFilter />}
        </Flex>
      </Flex>
    </>
  );
}

export default ReaderListHeader;
